import React, { Component } from "react";
import { Checkbox, Icon, Input, Select, message } from "antd";

import BucketSelector from "../BucketSelector";
import QueryView from "../QueryView";
import CloudFlyerAPI from "../../../api/CloudFlyerAPI";

import "./styles.scss";

export default class SearchView extends Component {
  constructor(props) {
    super(props);

    this.default_cloud = { project_name: "All Clouds", id: "" };
    this.default_bucket = { bucket_name: "All Buckets", id: "" };

    this.state = {
      keyword: "",
      context: [],
      loading: false,

      query: {},
      show_query: false,

      clouds: [this.default_cloud],
      selected_cloud_id: "",
      selected_bucket_id: "",

      selected_cloud: this.default_cloud,
      selected_bucket: this.default_bucket,

      canSearch: false,
      resultsCount: 200
    };
    this.tm = null;

    this.timeOutSearch = this.timeOutSearch.bind(this);
  }

  componentDidMount() {
    this.timeOutSearch(this.state.keyword);
  }

  componentWillReceiveProps(props) {
    if (props.clouds && props.clouds.length)
      this.setState({ clouds: [this.default_cloud].concat(props.clouds) });
  }

  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo);
  }

  on_cloud_change = id =>
    this.setState(
      {
        selected_cloud: this.state.clouds.filter(c => c.id === id)[0] || {},
        selected_cloud_id: id
      },
      () => this.on_bucket_change("")
    );

  on_bucket_change = id =>
    this.setState(
      {
        selected_bucket:
          (this.state.selected_cloud.storages || []).filter(
            c => c.id === id
          )[0] || {},
        selected_bucket_id: id
      },
      () => this.timeOutSearch(this.state.keyword)
    );

  timeOutSearch(keyword, newContext, newResultsCount) {
    clearTimeout(this.tm);
    this.tm = setTimeout(
      () => this.onSearch(keyword, newContext, newResultsCount),
      500
    );
  }

  onSearch = (keyword, newContext = null, newResultsCount = null) => {
    const { context, resultsCount } = this.state;

    const currentContext = newContext ? newContext : context;
    const currentResultsCount = newResultsCount
      ? newResultsCount
      : resultsCount;

    let searchQuery = {
      keyword,
      config: {
        limit: currentResultsCount,
        //type: "file",
        query_type: 'filter',
        bucket: (this.state.selected_bucket || {}).id
          ? (this.state.selected_bucket || {}).bucket_name
          : "",
        cloud_account_id: (this.state.selected_cloud || {}).id
      },
      context: []
    };

    if (currentContext.length !== 0) {
      searchQuery["context"] = currentContext;
      searchQuery.config["query_type"] = "filter";
    }

    this.setState({ keyword, loading: true });
    CloudFlyerAPI.mam
      .search(searchQuery)
      .then(({ data: { count = 0, results: files = [] } = {} }) =>
        this.setState({ loading: false }, () => this.props.on_results(files))
      )
      .catch(err => {
        this.setState({ loading: false });
        message.error(err.message);
      });
  };

  handleFiltersChange = context => {
    const { keyword } = this.state;
    this.setState({ context });
    this.timeOutSearch(keyword, context);
  };

  on_name_change = e => this.timeOutSearch(e.target.value);

  on_name_key_down = e => {
    if (e.keyCode === 13) this.timeOutSearch(e.currentTarget.value);
  };

  on_show_query = () => this.setState({ show_query: !this.state.show_query });

  render() {
    let {
      loading,
      show_query,
      selected_cloud_id,
      selected_bucket_id,
      clouds,
      selected_cloud: { storages = [] } = []
    } = this.state;
    storages = [this.default_bucket].concat(storages);

    const { onViewChange, view, onViewCountChange } = this.props;

    return (
      <div className="search-view">
        <header>
          <div className="search-by-name">
            <span className={"x-title"}>Search by File Name:</span>
            <Input
              placeholder="What are you looking for?"
              size="large"
              className={"search-file-name"}
              suffix={
                loading ? <Icon type="loading" /> : <Icon type="search" />
              }
              onKeyDown={this.on_name_key_down}
              onChange={this.on_name_change}
              autoFocus
            />
          </div>

          <BucketSelector
            header="Search by File Location:"
            selected_cloud_id={selected_cloud_id}
            selected_bucket_id={selected_bucket_id}
            clouds={clouds}
            buckets={storages}
            on_cloud_change={this.on_cloud_change}
            on_bucket_change={this.on_bucket_change}
          />
          <div className="select-files-number">
            <span className={"x-title"}>Number of results:</span>
            <Select
              defaultValue={20}
              size="large"
              className="number-select"
              onChange={onViewCountChange}
            >
              <Select.Option value={20}>20</Select.Option>
              <Select.Option value={50}>50</Select.Option>
              <Select.Option value={100}>100</Select.Option>
            </Select>
          </div>
          <div className="select-view">
            <span className={"x-title"}> View:</span>

            <div className="icon-div">
              <a href="#" onClick={() => onViewChange("table")}>
                <i
                  className="anticon anticon-table-view"
                  style={{
                    fontSize: 24,
                    color: view !== "table" ? "#d4d4d4" : "#737373"
                  }}
                >
                  <Icon type="ordered-list" theme="outlined" />
                </i>
              </a>
            </div>

            <div className="icon-div">
              <a href="#" onClick={() => onViewChange("list")}>
                <i
                  className="anticon anticon-list-view"
                  style={{
                    fontSize: 24,
                    color: view !== "list" ? "#d4d4d4" : "#737373"
                  }}
                >
                  <Icon type="table" theme="outlined" />
                </i>
              </a>
            </div>
          </div>
        </header>

        <QueryView
          onFilterBodyMade={this.handleFiltersChange}
          loading={loading}
          show_query={show_query}
          on_show_query={this.on_show_query}
        />
      </div>
    );
  }
}
